import { type Dispatch, type SetStateAction, useEffect, useRef } from 'react'
import type { Patient } from '@pbt/pbt-ui-components'

const RESET_DELAY_MS = 200

/**
 * After the shell first mounts, clearing `open` schedules clearing the selected patient so
 * reopening the flow starts from a neutral selection state.
 */
export function useResetSelectedPatientWhenClosed(
  open: boolean,
  setSelectedPatient: Dispatch<SetStateAction<Patient | undefined>>,
): void {
  const isFirstRun = useRef(true)

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false
      return undefined
    }
    if (!open) {
      const timeout = setTimeout(() => {
        setSelectedPatient(undefined)
      }, RESET_DELAY_MS)

      return () => {
        if (timeout) {
          clearTimeout(timeout)
        }
      }
    }

    return undefined
    // eslint-disable-next-line react-hooks/exhaustive-deps -- parity with InvoiceDialog: depend only on `open`
  }, [open])
}
